import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsCollectionPlay } from "react-icons/bs";
import { BiCaretRight } from "react-icons/bi";
import { ThemeContext } from '../../contexts/ThemeContext';
import './Footer.css';

const Footer = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const navigate = useNavigate();
  const [expandedSections, setExpandedSections] = useState({
    xemPhimThoai: true,
    theLoai: true,
    quocGia: true,
    trang: true,
    active: true
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const toggleSection = (section) => {
    setExpandedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div
            className="footer-title"
            onClick={() => toggleSection('xemPhimThoai')}
          >
            <BsCollectionPlay /> Xem phim thoai
          </div>
          {expandedSections.xemPhimThoai && (
            <ul className="footer-list">
              <li className="footer-list-item">
                Trang web xem phim trực tuyến miễn phí chất lượng cao với giao diện trực quan, tốc độ tải trang nhanh, cùng kho phim với hơn 40.000 phim mới, phim hay, cập nhật mỗi ngày, hứa hẹn sẽ đem lại phút giây thư giãn cho bạn.
              </li>
            </ul>
          )}
        </div>

        <div className="footer-section">
          <div
            className="footer-title"
            onClick={() => toggleSection('trang')}
          >
            <BsCollectionPlay /> Trang
          </div>
          {expandedSections.trang && (
            <ul className="footer-list">
              {/* <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/')}> <BiCaretRight /> Trang chủ</li> */}
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/phim-le')}> <BiCaretRight /> Phim lẻ</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/phim-bo')}> <BiCaretRight /> Phim bộ</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/hoat-hinh')}> <BiCaretRight /> Phim hoạt hình</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/tv-shows')}> <BiCaretRight /> TV Shows</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/lich-su')}> <BiCaretRight /> Lịch sử</li>
            </ul>
          )}
        </div>

        <div className="footer-section" id="the-loai">
          <div
            className="footer-title"
            onClick={() => toggleSection('theLoai')}
          >
            <BsCollectionPlay /> Thể loại
          </div>
          {expandedSections.theLoai && (
            <ul className="footer-list">
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/the-loai/tinh-cam')}> <BiCaretRight /> Tình cảm</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/the-loai/hanh-dong')}> <BiCaretRight /> Hành Động</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/the-loai/hai-huoc')}> <BiCaretRight /> Hài Hước</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/category/adventure')}> <BiCaretRight /> Phiêu Lưu</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/the-loai/kinh-di')}> <BiCaretRight /> Kinh dị</li>
            </ul>
          )}
        </div>

        <div className="footer-section" id="quoc-gia">
          <div
            className="footer-title"
            onClick={() => toggleSection('quocGia')}
          >
            <BsCollectionPlay /> Quốc gia
          </div>
          {expandedSections.quocGia && (
            <ul className="footer-list">
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/quoc-gia/viet-nam')}> <BiCaretRight /> Việt Nam</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/quoc-gia/han-quoc')}> <BiCaretRight /> Hàn Quốc</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/quoc-gia/trung-quoc')}> <BiCaretRight /> Trung Quốc</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/quoc-gia/thai-lan')}> <BiCaretRight /> Thái Lan</li>
              <li className="footer-list-item" id="li-hover" onClick={() => handleNavigation('/quoc-gia/au-my')}> <BiCaretRight /> Âu Mỹ</li>
            </ul>
          )}
        </div>
      </div>

      <div className="footer-disclaimer">
        <p>
          This website is a non-commercial project. All content displayed on this site is sourced from publicly available third-party APIs and is not hosted or owned by us. We do not claim ownership of any content shown here. This project is not intended for any commercial use. If you are a copyright owner and believe your content is displayed here without proper authorization, please contact us for its immediate removal. Users are advised to use this site at their own discretion and are responsible for complying with all applicable laws and regulations in their jurisdiction.
        </p>
      </div>

      <div className="footer-bottom">
        <p className="text-footer-bottom">
          © For more details, please contact us via <a href="mailto:services@xemphimthoai.site">services@xemphimthoai.site</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
